import Super from 'client-portal/controllers/-request/client-type';

export default class WidgetClientType extends Super {}
